import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailWidgetComponent } from './email-widget.component';
import { EmailBoxModule } from './email-box/email-box.module';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { CannedMessageModule } from 'shared/components/canned-message-panel/canned-message-panel.module';
import { CompactVisitorInfoModule } from 'shared/components/compact-visitor-info/compact-visitor-info.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { DiscussionsModule } from 'shared/components/discussions/discussions.module';

@NgModule({
  imports: [
    CommonModule,
    EmailBoxModule,
    WorkWidgetHeaderModule,
    CannedMessageModule,
    CompactVisitorInfoModule,
    VisitorHistoryModule,
    DiscussionsModule,
    LoadingModule
  ],
  declarations: [
    EmailWidgetComponent
  ],
  exports: [
    EmailWidgetComponent
  ]
})
export class EmailWidgetModule {}
